import * as React from 'react';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';

// Styles
import styles from './styles.scss';

type PriceLabelProps = {
    currency: string;
    label?: React.ReactNode;
    price: number;
    quantityDisplay?: string | null;
    showPriceVariability?: boolean | null;
};

export const PriceLabel: React.FC<PriceLabelProps> = ({
    price,
    label,
    quantityDisplay,
    currency,
    showPriceVariability,
}) => {
    const priceIntl = (
        <FormattedNumber
            value={price}
            currency={currency}
            style="currency"
            minimumFractionDigits={0}
            maximumFractionDigits={0}
        />
    );

    const priceVariabilityCopy = (
        <FormattedMessage id={'dc.searchProductTile.priceVariability'} defaultMessage={'From'} />
    );

    return (
        <div className={styles.priceLabel} data-tn="price">
            {showPriceVariability && priceVariabilityCopy}
            {showPriceVariability ? ' ' : ''}
            {priceIntl}
            {label ? ' ' : ''}
            {label}
            {quantityDisplay ? ' ' : ''}
            {quantityDisplay}
        </div>
    );
};

PriceLabel.defaultProps = {
    showPriceVariability: false,
};
